module.exports = __webpack_public_path__ + "7408a6ce8bbf74bcf5da2dce6f405909.svg";